var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryGym = function SvgCategoryGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 32,
    r: 14,
    fill: "#F7F4BA",
    transform: "rotate(-90 39 32)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 8.5,
    r: 3.5,
    fill: "#F7F4BA",
    transform: "rotate(-90 32.5 8.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 20.5,
    r: 9.5,
    fill: "#F7F4BA",
    transform: "rotate(-90 14.5 20.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E6B04",
    strokeWidth: 1.3,
    d: "M35.5 18.5a2.5 2.5 0 0 1 5 0v20a2.5 2.5 0 0 1-5 0zM20 18.5a2.5 2.5 0 0 0-5 0v20a2.5 2.5 0 0 0 5 0zM40.5 22.5a2.5 2.5 0 0 1 5 0v12a2.5 2.5 0 0 1-5 0zM15 22.5a2.5 2.5 0 0 0-5 0v12a2.5 2.5 0 0 0 5 0zM45.5 27a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM10 27a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E6B04",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M35.5 31v-5H20v5h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6E6B04",
    d: "M33.3 31a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  })));
};
export default SvgCategoryGym;